export default __webpack_public_path__ + "static/media/238.bf2918f5.jpg";